import * as ApiRequests from '../../api/requests';
import { AuthHelper } from '../../types/auth-helper-types';
import { AppThunk } from '../actions';
import { SensorDetailsActions } from '../actions/sensor-detail-actions';

export const SensorDetailThunks = {
    sensorChannelDetailForm: (
        deviceId: string,
        channelListarray: any,
        authHelper: AuthHelper,
        addToast: Function,
        selectChannelAll?: boolean
    ): AppThunk => async (dispatch): Promise<void> => {

        if (selectChannelAll) {
            dispatch(SensorDetailsActions.sensorDetailsActionStarted());
            const payload = await ApiRequests.getSensorTrendData(
                { deviceId: deviceId, channelList: channelListarray },
                { authHelper }
            );

            if (payload.ok) {
                dispatch(
                    SensorDetailsActions.sensorDetailsActionSucceeded(payload.httpStatusCode, payload.response.data)
                );
            } else {
                addToast(ApiRequests.extractResponseNotOkMessage(payload.response), 'error');
                dispatch(
                    SensorDetailsActions.sensorDetailsActionFailed(
                        `${ApiRequests.extractResponseNotOkCode(payload.response)}`
                    )
                );
            }
        } else {
            const filterChannelList: any = [];
            channelListarray
                .sort((a: any, b: any) => Number(a) - Number(b))
                .forEach((element: any) => {
                    const obj = {
                        channelNumber: element,
                    };
                    filterChannelList.push(obj);
                });

            dispatch(SensorDetailsActions.sensorDetailsActionStarted());

            const payload = await ApiRequests.getSensorTrendData(
                { deviceId: deviceId, channelList: filterChannelList },
                { authHelper }
            );

            if (payload.ok) {
                dispatch(
                    SensorDetailsActions.sensorDetailsActionSucceeded(payload.httpStatusCode, payload.response.data)
                );
            } else {
                addToast(ApiRequests.extractResponseNotOkMessage(payload.response), 'error');
                dispatch(
                    SensorDetailsActions.sensorDetailsActionFailed(
                        `${ApiRequests.extractResponseNotOkCode(payload.response)}`
                    )
                );
            }
        }
    },
};
